import { useContext } from 'react';
import { useLocalObservable } from 'mobx-react';

import LoginService from '../Services/LoginService';
import LoginContext from '../Contexts/LoginContext';
import { useApi, useAuth } from '@ibe/components';

export default function useMMBLoginService(): LoginService {
  const context = useContext(LoginContext);
  const loginService = useLocalObservable<LoginService>(() => context);
  const api = useApi();
  const auth = useAuth();

  loginService.setApi(api);
  loginService.setAuth(auth.authService);

  return loginService;
}
